<div>
  @if (ordersListLoading()) {
    <div class="flex justify-center p-4">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (ordersListError()) {
    <div class="flex justify-center p-4">
      <p class="text-red-500">{{ errorText }}</p>
    </div>
  } @else {
    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="dataSource"
        [matSortActive]="currentSort.active"
        [matSortDirection]="currentSort.direction"
        matSort
        (matSortChange)="sortData($event)"
        class="w-full"
      >
        <ng-container matColumnDef="orderId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Job #
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.orderId }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Description
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.description }}</td>
        </ng-container>

        <ng-container matColumnDef="clientPurchaseOrder">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Client PO #
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.clientPurchaseOrder }}
          </td>
        </ng-container>

        <ng-container matColumnDef="caNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            CA #
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.caNumber.caNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="promisedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Due Date
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.dueDate | date: CONFIG.date.dueDateFormat }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateCreated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Date Created
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.dateCreated | date: CONFIG.date.createdDateFormat }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Status
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.status }}</td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Client
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.client }}</td>
        </ng-container>

        <ng-container matColumnDef="assignee">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Assignee
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.assignee }}</td>
        </ng-container>

        <ng-container matColumnDef="totalQuantity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Quantity
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.quantity }}</td>
        </ng-container>

        <ng-container matColumnDef="orderTotalPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Total Price
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.totalPrice | currency: 'USD' : 'symbol' : '1.0-2' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateUpdated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Last Edited
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.lastEdited | date: CONFIG.date.createdDateFormat }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-right w-24"></th>
          <td mat-cell *matCellDef="let element" class="border-b p-4 text-right">
            <div class="invisible group-hover:visible flex items-center justify-end gap-2">
              <button
                mat-icon-button
                matTooltip="Edit Order"
                [routerLink]="['/orders', element.id, 'edit']"
                (click)="$event.stopPropagation()"
                class="text-gray-700"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [routerLink]="['/orders', row.id, 'view']"
          class="hover:bg-gray-100 cursor-pointer order-row group"
        ></tr>
      </table>
      <div
        *ngIf="!ordersListLoading() && !ordersListError() && dataSource.data.length === 0"
        class="text-center text-gray-500 py-8"
      >
        There are no records available.
      </div>
    </div>

    <ciwc-pagination
      [currentPage]="pageIndex"
      [pageSize]="pageSize"
      [totalItems]="totalMyOrders"
      [pageSizeOptions]="pageSizeOptions"
      (pageChange)="handlePageEvent($event)"
    ></ciwc-pagination>

    <div *ciwcRoleAccess="['ROLE_SUPER_ADMIN']" class="flex justify-end mb-4">
      <p *ngIf="myOrdersTotalPrice()" class="text-lg">
        Past Due Orders Total Price :
        {{ myOrdersTotalPrice() | currency: 'USD' : 'symbol' : '1.0-2' }}
      </p>
    </div>
  }
</div>
